import styled from 'styled-components';
import V4LOGOWhite from '../assets/V4LOGOWhite.png';


const Footer = () => {
    return(
      <FooterBox>
        <FooterInner>
        <Footerimg src={V4LOGOWhite} alt="K360°REA" />
        <Footerinfo>
          <FooterLinks>개인정보처리방침 <span>·</span> 이용안내</FooterLinks>
          <span>Copyright © 2025 DroMii. All rights reserved.</span>
          <span>경기 성남시 수정구 창업로 43 LXStartupCenter 업무동 516호</span>
        </Footerinfo>
        </FooterInner>
      </FooterBox>
    );

};

export default Footer;



const FooterBox = styled.div`
  padding: 42px 0;
  background-color: #102e3a;
  color: rgba(255, 255, 255, 0.68);
`;

const FooterInner = styled.div`
  width: min(1120px, calc(100% - 48px));
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 28px;

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
  }
`;

const Footerimg = styled.img`
  width: clamp(150px, 16vw, 200px);
  height: auto;
`;
const Footerinfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.65;
`;

const FooterLinks = styled.span`
  color: rgba(255, 255, 255, 0.9);
  font-weight: 800;

  span {
    padding: 0 7px;
    color: #7bb5c0;
  }
`;
